// @ts-ignore
import VueProgressBar from 'vue-progressbar'
import Vue from 'vue'
const options = {
  color: '#d20a11',
  thickness: '2px',
  transition: {
    opacity: '0.2s',
    speed: '0.3s',
    termination: 300,
  },
}

Vue.use(VueProgressBar, options)
